import { SiteBodyContent } from './loaders';

export const SiteBody = () => <SiteBodyContent />;
